import messages from 'ra-language-english'

const filesLimit = parseInt(process.env.UPLOAD_FILES_LIMIT ?? '10')

export default {
  ...messages,
  resources: {
    invoices: {
      name: 'Invoice Advances',
      labelMenu: 'Advances',
      fields: {
        defaultSort: 'ID',
        invoiceId: 'INVOICE',
        importerName: 'BUYER',
        destinationCountry: 'COUNTRY',
        issuedDate: 'ISSUE DATE',
        dueDate: 'DUE DATE',
        invoiceAmount: 'AMOUNT',
        advanceAmount: 'ADVANCE',
        receivedAmount: 'RECEIVED AMOUNT',
        remainingBalance: 'BALANCE',
        feeAmount: 'FEES',
        cost: 'COST',
      },
      tabs: {
        advanced: 'ADVANCED',
        delayed: 'DELAYED',
        late: 'LATE',
        paid: 'PAID',
        defaulted: 'DEFAULTED',
        pendingAdvance: 'PENDINGADVANCE',
      },
      messages: {
        lateFeesDiscounted: 'late fees discounted',
        daysOverdueSingular: '<<delay>> day overdue.',
        daysOverduePlural: '<<delay>> days overdue.',
        delayedDetailDescriptionSingular:
          'This invoice was due <b><<currentDelay>> day ago</b>. Get it paid before <b><<dueDate>></b> to avoid late fees.',
        delayedDetailDescriptionPlural:
          'This invoice was due <b><<currentDelay>> days ago</b>. Get it paid before <b><<dueDate>></b> to avoid late fees.',
        lateWithoutPaymentDetailDescriptionSingular:
          'This invoice was due <b><<currentDelay>> day ago</b>.',
        lateWithoutPaymentDetailDescriptionPlural:
          'This invoice was due <b><<currentDelay>> days ago</b>.',
        lateWithPaymentDetailDescription:
          'Due on <<dueDate>>. It is <<currentDelay>> days overdue. Late fees apply.',
        fullDetailDescriptionSingular:
          'This invoice was <b><<delayLastPayment>> days overdue</b>. Late fees were charged.',
        fullDetailDescriptionPlural:
          'This invoice was <b><<delayLastPayment>> days overdue</b>. Late fees were charged.',
        approvedDetailDescription: 'Pending payment',
        remainingBalanceRequestedHoverText:
          'This is an estimated value based on a simulation. Once your advance is approved, you will see the final amount.',
        remainingBalanceApprovedHoverText:
          'The payout for the advance amount is in progress. Once it is confirmed, we’ll let you know.',
        advancedDescription: 'Advanced on <<advancedDate>>',
        dueDescription: 'Due on <<dueDate>>',
        paidDescription: 'Paid on <<lastPaymentDate>>',
        requestedDescription: 'Requested on <<createdAt>>',
        approvedDescription: 'Pending payment',
        onTimeStatus: 'ON TIME',
        delayedStatus: 'DELAYED',
        lateStatus: 'LATE',
        pendingStatus: 'PENDING',
        pendingReviewStatus: 'IN REVIEW',
        paidStatus: 'PAID',
        defaultedStatus: 'DEFAULTED',
        approvedStatus: 'APPROVED',
        pendingAdvanceStatus: 'PENDING ADVANCE',
        advancedStatus: 'ADVANCED',
        invoiceNumber: 'Invoice <<invoiceId>>',
        invalidDate: 'Invalid date',
        pastDate: 'Past date',
        notLastMonth: 'Not a last month date',
        biggerThanZero: 'Amount has to be bigger than 0',
      },
      events: {
        date: 'Date',
        description: 'Description',
        amount: 'Amount',
        notes: 'Notes',
        invoiceIssuedDescription: 'Invoice issued',
        invoiceAdvancedDescription: 'Invoice advanced',
        invoiceRequestedDescription: 'Advance requested',
        invoiceApprovedDescription: 'Approved advance',
        collectionReceivedDescription: 'Collection received',
        invoiceSettledDescription: 'Invoice Settled',
        remainingBalanceDescription: 'Remaining balance',
        invoiceRemainingBalancePaid: 'Remaining balance paid',
        creditedInBankAccountDescription: 'Credited in bank account',
        viewinvoiceAdvancedWire: 'View advance wire',
        viewcollectionReceivedWire: 'View collection wire',
        viewinvoiceSettledWire: 'View settlement wire',
        feesCollectedDescription: 'Fees collected',
        costAtRepayment: 'Cost at due date',
        adjustedFeesBiggerZero: 'Late fees',
        adjustedFeesLessThanZero: 'Prepayment fees',
      },
      empty: {
        advanced: {
          noInvoices: {
            message: 'You haven’t advanced any invoice yet, start now!',
            button: 'Request your first advance',
          },
          paidInvoices: {
            message: 'You don’t have any outstanding advance at the moment.',
            button: 'Request your next advance',
          },
          delayedLateInvoices: {
            message: 'Don’t miss the opportunity to request an advance.',
            button: 'Request your next advance',
          },
        },
        delayed: {
          noInvoices: {
            message: 'You haven’t advanced any invoice yet, start now!',
            button: 'Request your first advance',
          },
          noDelayedNoLateInvoices: {
            message: 'Yay! No delayed or late invoices!',
          },
          noDelayedLateInvoices: {
            message: 'You have no delayed invoice within the grace period.',
          },
        },
        late: {
          noInvoices: {
            message: 'You haven’t advanced any invoice yet, start now!',
            button: 'Request your first advance',
          },
          noDelayedLateInvoices: {
            message: 'Yay! No delayed or late invoices!',
          },
          noLateInvoices: {
            message: 'You have no late invoice accumulating extra fees.',
          },
        },
        paid: {
          noInvoices: {
            message: 'You haven’t advanced any invoice yet, start now!',
            button: 'Request your first advance',
          },
          noPaidInvoices: {
            message: 'No paid invoices so far.',
          },
        },
      },
      actions: {
        create: {
          name: 'Advance your invoices',
          nameAlt: 'Request the advance of your invoices.',
          request: {
            title: 'Invoice Advance Request',
            subtitle:
              'Please, enter the information of the invoice you’d like to advance.',
            invoiceNumber: 'Invoice Number',
            buyer: 'Buyer',
            issueDate: 'Issue Date',
            dueDate: 'Due Date',
            invoiceAmount: 'Invoice Amount',
            purchaseOrderNumber: 'Purchase Order Number',
          },
          upload: {
            title: 'Please, attach the following documentation',
            button: 'Upload Files',
            documentation: {
              title: 'Requested Documentation',
              invoice: 'Invoice',
              required: '(required)',
              proofOfDelivery: 'Proof of Delivery',
              purchaseOrder: 'Purchase Order',
              proofOfAgreedDueDate: 'Proof of agreed due date',
              infoHoverText:
                'Required if the purchase order doesn’t include the payment due date',
              sea: 'If transported by sea:',
              billOfLading: 'Bill of lading',
              insurancePolicy: 'Insurance policy',
            },
            uploadFileDialog: {
              title: `You can upload up to ${filesLimit} files of 50 MB each`,
              text: 'Drag and drop a file here or click',
              previewText: 'Selected Files:',
              getFileAddedMessage: 'Uploading {{fileName}} ...',
              fileLimitExceedMessage:
                'Maximum allowed number of files exceeded. Only {{filesLimit}} allowed',
              maxFileSizeMessage: 'Maximum supported file size is 50mb',
              fileAddedMessage: 'File {{fileName}} successfully added.',
              fileRemovedMessage: 'File {{fileName}} removed.',
              dropRejectMessage: 'File {{rejectedFileName}} was rejected.',
              cancel: 'Cancel',
              submit: 'Accept',
              close: 'Close',
              uploadFile: 'Upload files',
              signDocument: 'Sign Document',
              signedDocument: 'Document Signed',
              signedDocumentBy: '<0>{{signer}}</0> signed the document',
              dismissSnackBar: 'Dismiss',
              uploadingFile: 'File {{fileName}} is uploading...,',
              fileUploaded: 'File {{fileName}} uploaded',
              fileTypeError: 'File type not supported',
              maxFilesUploaded:
                'Maximum {{filesLimit}} documents allowed, please remove some to upload more',
              fileUploadError:
                'An error occurred while trying to upload the file {{fileName}}',
            },
          },
          summary: {
            title: 'Review advances to request',
            subtitle: 'Invoices included in advance request',
            edit: 'Edit',
            uploadFiles: 'Upload files',
            remove: 'Remove',
            fields: {
              buyer: 'Buyer',
              issueDate: 'Issue date',
              dueDate: 'Due date',
              amount: 'Amount',
              purchaseOrder: 'Purchase order',
              filesUploaded: 'Files uploaded',
            },
          },
          response: {
            title: 'We’re creating your advance request',
            error: 'An error has occurred. Please try again',
            descriptionSingular:
              'Your request to advance 1 invoice is being created. This will only take a few seconds. Once it’s done you’ll be able to close this window and see listed the advances.',
            descriptionPlural:
              'Your request to advance {invoiceCount} invoices is being created. This will only take a few seconds. Once it’s done you’ll be able to close this window and see listed the advances.',
            sign: 'Team Mundi',
          },
          submit: 'Submit',
          finish: 'Finish',
          continue: 'Continue',
          submitTooltip: 'Submit your request',
          cancel: 'Cancel',
          next: 'Next',
          back: 'Back',
          close: 'Close',
          add: 'Add another invoice',
          confirmCancelTitle: 'Discard Advance',
          confirmCancelSingular:
            'You’re about to discard this advance request (including 1 invoice added). Are you sure you want to proceed?',
          confirmCancelPlural:
            'You’re about to discard this advance request (including the {invoicesCount} invoices added). Are you sure you want to proceed?',
          confirm: 'Exit',
          yesDiscard: 'Yes, discard advance',
          noDiscard: 'No',
          discard: 'Discard Advance',
        },
        export: {
          name: 'Export',
          all: 'All buyers',
        },
      },
    },
    payments: {
      name: 'Payments',
      labelMenu: 'Payments',
      payment: {
        id: 'ID',
        date: 'DATE',
        importerName: 'PAYER',
        description: 'DESCRIPTION',
        amount: 'AMOUNT',
        notes: 'NOTES',
      },
      events: {
        invoice: 'Invoice',
        date: 'Date',
        description: 'Description',
        amount: 'Amount',
      },
      empty: {
        title:
          'Here you’ll find the payments received from Mundi for any requested advance.',
        subtitle:
          'You’ll be able to export this information into an Excel (.xlsx) file.',
      },
      messages: {
        advancedPaymentTransaction: 'Advance payment transaction',
        balancePaymentTransaction: 'Balance payment transaction',
        collectionForwardTransaction: 'Collection forward transaction',
        paymentCollectionDescription: 'Collection received',
        mundi: 'Mundi',
        downloadReceipt: 'Download Receipt',
        invoiceLinkedToEntry: 'Entries',
        invoiceAdvance: 'Invoice Advance',
        invoiceBalance: 'Invoice balance',
        collectionForward: 'Collection forward',
        invoiceSettlement: 'Invoice Settlement',
        invoiceCollection: 'Invoice Collection',
        uncollectable: 'Collection Forward',
        noInvoice: 'N/A',
      },
      actions: {
        export: {
          name: 'Export',
          all: 'All Transactions',
          payments: 'Payments Only',
          error: "We couldn't export this file, try again later",
        },
      },
    },
    collections: {
      name: 'Collections',
      labelMenu: 'Collections',
      empty: {
        title: 'Here you’ll find the payments we collect from your clients.',
        subtitle:
          'You’ll be able to export this information into an Excel (.xlsx) file.',
      },
      actions: {
        export: {
          name: 'Export',
          all: 'All Transactions',
          collections: 'Collections Only',
        },
      },
    },
    creditlines: {
      name: 'Credit lines',
      labelMenu: 'Credit lines',
      creditline: {
        id: 'ID',
        importerName: 'BUYER',
        openedOn: 'OPENED ON',
        lineAmount: 'LINE SIZE',
        currentlyAvailable: 'AVAILABLE',
        maxTerm: 'MAX TERM',
        maxAdvanceRate: 'MAX ADVANCE RATE',
        monthlyCost: 'MONTLY COST',
        status: 'STATUS',
        activeStatus: 'ACTIVE',
        openStatus: 'OPEN',
        closedStatus: 'CLOSED',
        gracePeriod: 'GRACE PERIOD',
        currentlyAllocated: 'ALLOCATED',
      },
      events: {
        invoice: 'INVOICE',
        issueDate: 'ISSUE DATE',
        dueDate: 'DUE DATE',
        inUsed: 'IN USED',
        repaidAmount: 'REPAID AMOUNT',
        empty: {
          noInvoice: {
            message: 'Start using this line by requesting your first advance.',
            button: 'Request an advance',
          },
          table: {
            message: 'You don’t have any outstanding advance at the moment.',
            button: 'Request your next advance',
          },
        },
      },
      messages: {
        day: 'day',
        days: 'days',
        openedOn: 'Opened on <<openedOn>>',
        currentlyAllocated: 'Currently allocated',
        currentlyAdvancedInvoices: 'Currently Advanced Invoices (<<N>>)',
        invoiceHistory: 'Invoice history (<<N>>)',
        totalUsed: 'Total used',
      },
      empty: 'You haven’t credit lines yet.',
    },
  },
  account: {
    login: {
      title: 'Sign in',
      email: 'Email',
      emailError: 'Please enter a valid email',
      password: 'Password',
      passwordError: 'Please enter a valid password',
      button: 'Login',
      loginErrorTitle: 'Login failed',
      loginErrorBody:
        'The email and/or password entered are not valid. Please, try again.',
      passwordVisibility: 'Toggle password visibility',
    },
    activation: {
      title: 'Activate your account',
      passwordConfirmation: 'Password confirmation',
      passwordConfirmationError: "Passwords don't match",
      button: 'Activate',
    },
    verification: {
      successTitle: 'Email verified',
      successBody:
        'Your email was successfully verified!\nIn the next 24hs your account representative will contact you to finish the onboarding process.\n\nWelcome to Mundi!\n\n- Team Mundi',
    },
  },
  notFound: {
    title: 'Oops! Page not found',
    subtitle:
      'Apparently the page you’re trying to access does not exist or it’s momentously unavailable',
    button: 'Back to Mundi',
  },
}
